import Vue from 'vue'
import VueRouter from 'vue-router'
import WarrantyQuery from '../views/warranty/index.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'WarrantyQuery',
        component: WarrantyQuery
    }
]

const router = new VueRouter({
    mode: 'history',
    base: '/livolteksale-product/',
    routes
})

export default router
